var map = {
	"./add.svg": 48157,
	"./add_active.svg": 63766,
	"./add_tabs.svg": 48276,
	"./ai.svg": 44110,
	"./ai_active.svg": 96515,
	"./alfred.svg": 42164,
	"./android.svg": 82113,
	"./android_active.svg": 15730,
	"./apple.svg": 8604,
	"./arrow.svg": 65807,
	"./arrow_alt.svg": 16895,
	"./article.svg": 51034,
	"./article_active.svg": 98391,
	"./audio.svg": 29034,
	"./back.svg": 4941,
	"./blank.svg": 32782,
	"./book.svg": 33779,
	"./broken.svg": 60155,
	"./broken_active.svg": 62700,
	"./cache_failed.svg": 19994,
	"./cache_ready.svg": 25446,
	"./cache_retry.svg": 89721,
	"./calendar.svg": 92934,
	"./check.svg": 67772,
	"./check_active.svg": 4697,
	"./clear.svg": 97891,
	"./click.svg": 73548,
	"./close.svg": 88008,
	"./cloud.svg": 59863,
	"./cloud_active.svg": 17872,
	"./day.svg": 34922,
	"./default_collection.svg": 78734,
	"./default_collection_active.svg": 58371,
	"./dev.svg": 70105,
	"./dev_active.svg": 66138,
	"./diamond.svg": 36384,
	"./diamond_active.svg": 8405,
	"./document.svg": 33903,
	"./download.svg": 84604,
	"./dropbox.svg": 50538,
	"./dropbox_active.svg": 61639,
	"./duplicates.svg": 84014,
	"./duplicates_active.svg": 19939,
	"./edit.svg": 43760,
	"./edit_active.svg": 90725,
	"./exit.svg": 45028,
	"./export.svg": 58622,
	"./export_active.svg": 25587,
	"./extension.svg": 39763,
	"./extension_active.svg": 37524,
	"./facebook.svg": 31256,
	"./fonts.svg": 51698,
	"./fonts_active.svg": 33119,
	"./fullscreen.svg": 42967,
	"./fullscreen_active.svg": 77680,
	"./gdrive.svg": 25561,
	"./gdrive_active.svg": 24314,
	"./github.svg": 71337,
	"./google.svg": 91057,
	"./help.svg": 52421,
	"./hide.svg": 42804,
	"./highlights.svg": 35207,
	"./history.svg": 32148,
	"./history_active.svg": 19041,
	"./hotkey.svg": 38770,
	"./ifttt.svg": 5007,
	"./image.svg": 36699,
	"./image_active.svg": 25804,
	"./import.svg": 98771,
	"./import_active.svg": 57748,
	"./inbox.svg": 58748,
	"./inbox_active.svg": 23705,
	"./info.svg": 28360,
	"./install.svg": 8061,
	"./install_active.svg": 41878,
	"./integrations.svg": 76717,
	"./integrations_active.svg": 54790,
	"./like.svg": 6501,
	"./like_active.svg": 38766,
	"./like_outline.svg": 18234,
	"./link.svg": 13796,
	"./link_active.svg": 71857,
	"./lock.svg": 59481,
	"./markdown.svg": 30999,
	"./menu.svg": 45673,
	"./micro_add.svg": 3348,
	"./micro_ai.svg": 26477,
	"./micro_arrow.svg": 61250,
	"./micro_article.svg": 38003,
	"./micro_audio.svg": 30003,
	"./micro_book.svg": 25592,
	"./micro_broken.svg": 75616,
	"./micro_cache_failed.svg": 88477,
	"./micro_calendar.svg": 80941,
	"./micro_close.svg": 48705,
	"./micro_cloud.svg": 32538,
	"./micro_colapse.svg": 85700,
	"./micro_comment.svg": 51002,
	"./micro_document.svg": 14452,
	"./micro_download.svg": 19955,
	"./micro_duplicate.svg": 64018,
	"./micro_edit.svg": 76555,
	"./micro_expand.svg": 22779,
	"./micro_image.svg": 28630,
	"./micro_important.svg": 73695,
	"./micro_important_active.svg": 75688,
	"./micro_link.svg": 22307,
	"./micro_list.svg": 48379,
	"./micro_next.svg": 31944,
	"./micro_open.svg": 82979,
	"./micro_progress.svg": 13826,
	"./micro_public.svg": 17120,
	"./micro_reminder.svg": 68669,
	"./micro_screenshot.svg": 58475,
	"./micro_search.svg": 19171,
	"./micro_tag.svg": 49521,
	"./micro_tune.svg": 21841,
	"./micro_user.svg": 17710,
	"./micro_video.svg": 61964,
	"./more.svg": 72087,
	"./more_horizontal.svg": 30358,
	"./move_to.svg": 39309,
	"./move_to_active.svg": 16358,
	"./new_bookmark.svg": 47001,
	"./new_collection.svg": 70757,
	"./new_collection_active.svg": 32686,
	"./next.svg": 8071,
	"./night.svg": 69302,
	"./note.svg": 94016,
	"./onedrive.svg": 44128,
	"./onedrive_active.svg": 82485,
	"./open.svg": 46964,
	"./public.svg": 85839,
	"./public_active.svg": 5496,
	"./raindrop_logo.svg": 65173,
	"./readwise.svg": 42712,
	"./refresh.svg": 72365,
	"./reminder.svg": 81390,
	"./reminder_active.svg": 72931,
	"./reminder_add.svg": 71262,
	"./rss.svg": 79616,
	"./search.svg": 39944,
	"./select_all.svg": 53699,
	"./select_none.svg": 11325,
	"./settings.svg": 11059,
	"./settings_active.svg": 37492,
	"./share.svg": 6013,
	"./sharing.svg": 9336,
	"./sharing_active.svg": 96733,
	"./show.svg": 70535,
	"./show_active.svg": 62208,
	"./sidebar.svg": 92192,
	"./sidebar_alt.svg": 72676,
	"./sidebar_alt_active.svg": 80241,
	"./slack.svg": 39620,
	"./sort_+lastUpdate.svg": 33005,
	"./sort_+lastUpdate_active.svg": 93126,
	"./sort_-created.svg": 43888,
	"./sort_-created_active.svg": 45701,
	"./sort_-domain.svg": 24252,
	"./sort_-domain_active.svg": 76761,
	"./sort_-lastUpdate.svg": 25179,
	"./sort_-lastUpdate_active.svg": 29164,
	"./sort_-title.svg": 29570,
	"./sort_-title_active.svg": 82479,
	"./sort_created.svg": 98177,
	"./sort_created_active.svg": 14482,
	"./sort_domain.svg": 19747,
	"./sort_domain_active.svg": 79940,
	"./sort_rating.svg": 34376,
	"./sort_rating_active.svg": 92941,
	"./sort_score.svg": 52391,
	"./sort_score_active.svg": 22496,
	"./sort_sort.svg": 41331,
	"./sort_sort_active.svg": 84148,
	"./sort_title.svg": 50891,
	"./sort_title_active.svg": 28028,
	"./tag.svg": 99036,
	"./tag_active.svg": 83417,
	"./trash.svg": 69706,
	"./trash_active.svg": 71687,
	"./twitter.svg": 45001,
	"./twitter_outline.svg": 67926,
	"./type.svg": 59004,
	"./upload.svg": 71663,
	"./upload_active.svg": 66552,
	"./user.svg": 35941,
	"./user_active.svg": 88046,
	"./video.svg": 37533,
	"./video_active.svg": 12854,
	"./view_grid.svg": 72010,
	"./view_grid_active.svg": 93927,
	"./view_list.svg": 9086,
	"./view_masonry.svg": 71371,
	"./view_simple.svg": 21516,
	"./vkontakte.svg": 98563,
	"./web.svg": 72158,
	"./web_active.svg": 54419,
	"./youtube.svg": 57535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35450;